/**
 * a boolean of if under brave browser
 * reference: https://stackoverflow.com/a/60954062
 */
const isBraveBrowser = !!(
  navigator as typeof navigator & { brave: Record<string, unknown> }
).brave

export default isBraveBrowser
